// Firebase設定と初期化
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// 環境変数からFirebase設定を読み込み
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// 設定値の検証とデバッグ情報
const requiredEnvVars = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID'
];

const missingVars = requiredEnvVars.filter(varName => !process.env[varName]);
if (missingVars.length > 0) {
  console.error('Missing Firebase environment variables:', missingVars);
  console.error('Please check your .env file and ensure all required Firebase variables are set.');
} else {
  // Firebase config loaded successfully
}

// Firebase初期化
const app = initializeApp(firebaseConfig);

// Auth設定
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Firestore設定
export const db = getFirestore(app);

// Storage設定
export const storage = getStorage(app);

// Google認証プロバイダーの設定
googleProvider.setCustomParameters({
  prompt: 'select_account',
  // カスタムパラメーターでブランド表示を改善
  hd: '', // 特定ドメイン制限なし
});

// Google provider configured for domain: ${window.location.origin}

export default app;
